import { render, staticRenderFns } from "./ViewRequestDetailReadOnly.vue?vue&type=template&id=cfd1c7fe&"
import script from "./ViewRequestDetailReadOnly.vue?vue&type=script&lang=js&"
export * from "./ViewRequestDetailReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports